export default __webpack_public_path__ + "static/media/coin.fe96d444.png";